module.exports = __webpack_public_path__ + "static/media/component-6.fb5f256a.svg";